<template>
  <LogOut msg="Hello dev !"/>
</template>

<script>
import LogOut from './components/LogOut.vue'

export default {
  name: 'App',
  components: {
    LogOut
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
